import { Grid, Box, Typography } from "@mui/material";
import theme from "themeProvider";
import PropTypes from "prop-types";

const borderColor = `2px solid ${theme.palette.grey["400"]}`;

const HoverBlock = ({ data, title, firstColumnXs = 4, secondColumnXs = 8 }) => {
  return (
    <>
      {data && (
        <Box
          width={250}
          p={2}
          borderRight={title !== "Seller" && borderColor}
          borderLeft={title === "Pick Up Details" && borderColor}
        >
          <Box p={2} pl={0} borderBottom={borderColor}>
            <Typography fontWeight={"bold"}> {title}</Typography>
          </Box>
          {Object.entries(data).map(([key, value], _) => (
            <Grid container key={key} pt={2} pb={2}>
              <Grid item xs={firstColumnXs}>
                <Typography fontSize={12}>{key}</Typography>
              </Grid>
              <Grid item xs={secondColumnXs}>
                <Typography fontSize={12} fontWeight={"bold"}>
                  {value}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      )}
    </>
  );
};

export const SellerJODLHoverBlock = ({
  sourceSellerData,
  jodlData,
  pickupData,
  buyerData,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: theme.palette.common.white,
        width: 1000,
      }}
      borderRadius={1}
      boxShadow={`0 0 3px 2px ${theme.palette.text.secondary}`}
    >
      <HoverBlock data={sourceSellerData} title={"Source seller"} />
      <HoverBlock data={jodlData} title={"Seller"} />
      <HoverBlock data={pickupData} title={"Pick Up Details"} />
      <HoverBlock data={buyerData} title={"Buyer Details"} />
    </Box>
  );
};

SellerJODLHoverBlock.propTypes = {
  sourceSellerData: PropTypes.object,
  jodlData: PropTypes.object,
  pickupData: PropTypes.object,
  buyerData: PropTypes.object,
};
